import React, { useEffect } from 'react';
import { filterTextForJaws } from '../../../misc/helpers';
import './Feedback.css';

const Feedback = (obj: any) => {
	useEffect(() => {
		setTimeout(() => {
			(document.querySelector('.feedback-container p') as any).focus();
		}, 0);
	}, [obj.parameters.message]);
	return (
		<div className="ui-container feedback-background modal-disable-select">
			<div className="feedback-container">
				<p tabIndex={0} aria-label={filterTextForJaws(obj.parameters.message)}>{obj.parameters.message}</p>
			</div>
		</div>
	);
};

export default Feedback;
